import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './UserCard.module.scss';
import Button from '../../common/Button';
import SlideCard from '../../common/SlideCard';
import SimpleCheckbox from '../../common/SimpleCheckbox';
import { fullName } from '../../../utils/textHelper';

const NO_PERMISSIONS = 'none';
const HAS_PERMISSIONS = 'write';

function UserCard(props) {
  const { data, isCurrentUser } = props;
  const { user, email } = data;

  const [permissions, setPermissions] = useState({
    dropship: data.ecommerce_permission,
    replenish: data.replenish_permission,
    administration: data.administration_permission,
  });

  const onSubmit = () => {
    const data = {
      administration_permission: permissions.administration,
      ecommerce_permission: permissions.dropship,
      replenish_permission: permissions.replenish,
    };

    if (user) {
      props.submit(user.id, data);
    } else {
      props.submitUserNotRegistered(email, data);
    }
  };

  const buttonIsDisabled = () => {
    return (
      permissions.dropship !== HAS_PERMISSIONS &&
      permissions.replenish !== HAS_PERMISSIONS &&
      permissions.administration !== HAS_PERMISSIONS
    );
  };

  const handleChangeCheckbox = (name, value) => {
    setPermissions({
      ...permissions,
      [name]: value ? HAS_PERMISSIONS : NO_PERMISSIONS,
    });
  };

  const deleteUser = () => {
    if (user) {
      props.openConfirmModal(user, 'delete');
    } else {
      props.deleteUserNotRegistered(email);
    }
  };
  const showUnblockButton = user && user.blocked_date;

  const title = user ? fullName(user) : `${email} (Invited)`;
  const titleButton = isCurrentUser ? (
    <span>Current User</span>
  ) : (
    <div>
      {showUnblockButton && (
        <button className={styles.unblock} onClick={() => props.openConfirmModal(user, 'unblock')}>
          unblock
        </button>
      )}
      <button className={styles.delete} onClick={deleteUser}>
        {user ? 'Remove' : 'Uninvite'}
      </button>
    </div>
  );

  return (
    <SlideCard title={title} right={titleButton} active={false} toggle>
      <div className={styles.container}>
        <div className={styles.info}>
          <div>
            <dl>
              {user && (
                <div className={styles.main_wrap}>
                  <div className={styles.wrap}>
                    <dt>First name:</dt>
                    <dd>{user.first_name}</dd>
                  </div>
                  <div className={styles.wrap}>
                    <dt>Last name:</dt>
                    <dd>{user.last_name}</dd>
                  </div>
                </div>
              )}

              <dt>Allowed services:</dt>
              <dd>
                <SimpleCheckbox
                  checked={permissions.replenish === HAS_PERMISSIONS}
                  label="Reorder"
                  value={permissions.replenish}
                  onChange={(checked) => handleChangeCheckbox('replenish', checked)}
                />
              </dd>
              <dt />
              <dd>
                <SimpleCheckbox
                  checked={permissions.dropship === HAS_PERMISSIONS}
                  label="Drop Ship"
                  value={permissions.dropship}
                  onChange={(checked) => handleChangeCheckbox('dropship', checked)}
                />
              </dd>
              <dt />
              <dd>
                <SimpleCheckbox
                  checked={permissions.administration === HAS_PERMISSIONS}
                  disabled={isCurrentUser}
                  label="Retailer Administration"
                  value={permissions.administration}
                  onChange={(checked) => handleChangeCheckbox('administration', checked)}
                />
              </dd>
            </dl>
          </div>
          <div>
            <dl>
              {user && (
                <div className={styles.wrap}>
                  <dt>Phone number:</dt>
                  <dd>{user.phone}</dd>
                </div>
              )}

              <dt>E-mail:</dt>
              <dd>
                <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
                  {email}
                </a>
              </dd>
            </dl>

            <Button text="Update Permissions" onClick={onSubmit} disabled={buttonIsDisabled()} />
          </div>
        </div>
      </div>
    </SlideCard>
  );
}

export default UserCard;

UserCard.defaultProps = {
  isCurrentUser: false,
};

UserCard.propTypes = {
  data: PropTypes.shape({
    administration_permission: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    ecommerce_permission: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    replenish_permission: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    user: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.object]),
    email: PropTypes.string.isRequired,
  }).isRequired,
  submit: PropTypes.func.isRequired,
  openConfirmModal: PropTypes.func.isRequired,
  submitUserNotRegistered: PropTypes.func.isRequired,
  deleteUserNotRegistered: PropTypes.func.isRequired,
  isCurrentUser: PropTypes.bool,
};
